import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

// material-ui
import { Grid } from '@mui/material';

// project imports
import Loader from './Loader';
import { gridSpacing } from 'store/constant';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component) => {
  const SuspenseWrapper = (props) => {
    const location = useLocation();

    return (
      <Suspense
        fallback={
          <Grid
            container
            spacing={gridSpacing}
            height={location.pathname === '/login' ? '100vh' : '100%'}
          >
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <Loader />
            </Grid>
          </Grid>
        }
      >
        <Component {...props} />
      </Suspense>
    );
  };

  return SuspenseWrapper;
};

export default Loadable;
